document.addEventListener( 'DOMContentLoaded', function ( event ) {
	document.querySelectorAll('.products-megamenu').forEach( ( productsNav ) => {
		const mainNavItems = productsNav.querySelectorAll('.products-megamenu__menu > li');
		const imagePreview = productsNav.querySelector('.products-megamenu__right img');
		const backButton = productsNav.querySelector('.products-megamenu__back');
		mainNavItems.forEach( ( navItem ) => {
			const productImage = navItem.dataset.image;
			const subNavTrigger = navItem.querySelector('.products-megamenu__item-container');
			if ( subNavTrigger ) {
				subNavTrigger.addEventListener( 'click', function() {
					if ( window.innerWidth <= 1279 ) {
						if ( navItem.classList.contains( 'active' ) ) {
							navItem.classList.remove( 'active' );
						} else {
							navItem.classList.add( 'active' );
						}
					} else {
						mainNavItems.forEach( ( item ) => item.classList.remove( 'active' ) );
						navItem.classList.add( 'active' );
						imagePreview.src = productImage;
					}
				} );
			}
		} );

		if ( backButton ) {
			backButton.addEventListener( 'click', function( e ) {
				e.preventDefault();
				productsNav.classList.remove( 'open' );
			} );
		}
	} );
}, { once: true } );
